/* Timestamp of the server row this device last successfully synced with
 * (either pushed to, or pulled from). Lets the client tell "server changed
 * since I last synced" (adopt it) apart from "server is just what I wrote
 * last time, or hasn't caught up with my last edit yet" (keep local — a
 * stale/incomplete server copy must never clobber a fresher local one). */
const SYNCED_AT_KEY = 'xceller_fitness_synced_at';
export function getSyncedAt() {
  try { return localStorage.getItem(SYNCED_AT_KEY) || null; } catch { return null; }
}
export function setSyncedAt(value) {
  if (!value) return;
  try { localStorage.setItem(SYNCED_AT_KEY, value); } catch {}
}

/* Versioned sync. The server bumps `version` on every write and refuses
 * (409) a PUT whose base_version is stale, so a write from another device
 * or from Claude (MCP server) is never silently overwritten. To rebase local
 * edits onto a newer server copy we keep the copy we last synced with (the
 * merge base) and its version. `pending` fingerprints a PUT whose response
 * may never arrive (app killed), so the next load recognises that write as
 * our own instead of as a conflicting edit. */
const SYNC_VERSION_KEY = 'xceller_fitness_synced_version';
const SYNC_BASE_KEY = 'xceller_fitness_synced_base';
const SYNC_PENDING_KEY = 'xceller_fitness_pending_put';
// Which account the local fitness state belongs to. The local store isn't
// per-user, so without this a second account signing in on the same browser
// would get the first account's unsynced edits merged into its own data.
const SYNC_OWNER_KEY = 'xceller_fitness_owner';
export function readSyncMeta() {
  try {
    const v = localStorage.getItem(SYNC_VERSION_KEY);
    const base = localStorage.getItem(SYNC_BASE_KEY);
    const pending = localStorage.getItem(SYNC_PENDING_KEY);
    return {
      version: v != null && /^\d+$/.test(v) ? Number(v) : null,
      base: base ? JSON.parse(base) : null,
      pending: pending ? JSON.parse(pending) : null,
      owner: localStorage.getItem(SYNC_OWNER_KEY),
    };
  } catch { return { version: null, base: null, pending: null, owner: null }; }
}
export function writeSyncMeta(version, base, owner) {
  try { if (owner != null) localStorage.setItem(SYNC_OWNER_KEY, String(owner)); } catch {}
  try { localStorage.setItem(SYNC_VERSION_KEY, String(version)); } catch {}
  try { localStorage.setItem(SYNC_BASE_KEY, JSON.stringify(base)); } catch {
    // Storage full: drop the base rather than keep a stale one. Without a
    // base a newer server copy is adopted instead of merged.
    try { localStorage.removeItem(SYNC_BASE_KEY); } catch {}
  }
}
export function writePendingPut(pending) {
  try {
    if (pending) localStorage.setItem(SYNC_PENDING_KEY, JSON.stringify(pending));
    else localStorage.removeItem(SYNC_PENDING_KEY);
  } catch {}
}
